import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

/**
 * Fetch paginated list of themes from API.
 * @param {object} [query] - Optional query params to add to URL.
 * @returns {Promise<object>} API Response
 */
export function getThemes(query = {}) {
  return fetch(getUrl('/themes'), { query });
}

/**
 * Get list of all unique tags assigned to themes by owner.
 * @returns {Promise<object>}
 */
export function getTags() {
  return fetch(getUrl('/themes/tags'));
}

/**
 * Fetch paginated list of themes from API.
 * @param {Array<number>} themeIds - List of themes to fetch by ID.
 * @returns {Promise<object>} API Response
 */
export function getMultipleThemes(ids = []) {
  const query = {
    ids: ids.join(','),
  };

  return fetch(getUrl('/themes/many'), { query });
}
